export const FETCH_AUTH_REQUEST = "FETCH_AUTH_REQUEST";
export const FETCH_AUTH_SUCCESS = "FETCH_AUTH_SUCCESS";
export const FETCH_AUTH_FAILURE = "FETCH_AUTH_FAILURE";

export const REQUEST_HANDLER = "REQUEST_HANDLER";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";

export const UPDATE_AUTH = "UPDATE_AUTH";
export const DELETE_AUTH = "DELETE_AUTH";

export const AUTH_LOGOUT = "AUTH_LOGOUT";
